import http from "./httpservices";
import GetCookieByName from "../../hooks/GetCookie";

const endPoint = "report";

export async function FetchReports(params = {}) {
  return http.get(`${endPoint}`, {
    params,
    headers: { "x-auth-token": JSON.parse(GetCookieByName("auth"))["token"] },
  });
}

export async function FetchReportDetails(params) {
  const headers = {};
  try {
    const token = JSON.parse(GetCookieByName("auth"))?.token;
    if (token) headers["x-auth-token"] = token;
  } catch { /* no auth cookie — /details is public, proceed without header */ }
  return http.get(`${endPoint}/details`, { params, headers });
}

export async function AddReport(postdata) {
  return await http.post(`${endPoint}`, postdata);
  
}


export async function AddPostsByReport(postdata) {
  const { data } = await http.put(`${endPoint}/update/posts`, postdata);
  return data;
}

export async function FetchReportStatus(id) {
  return http.get(`${endPoint}/status/${id}`);
}

export async function RetryReport(id) {
  return http.post(`${endPoint}/retry/${id}`);
}

export async function FetchReportSnapshots(id) {
  return http.get(`${endPoint}/${id}/snapshots`);
}

export async function BackfillFollowers(id) {
  return http.post(`${endPoint}/backfill-followers/${id}`);
}

export async function FetchComments(id) {
  return http.post(`${endPoint}/${id}/fetch-comments`);
}

export async function GetPostComments(id) {
  return http.get(`${endPoint}/${id}/comments`);
}

export async function FetchRefreshInfo(id) {
  return http.get(`${endPoint}/${id}/refresh-info`);
}

// Public like FetchReportDetails — must also work for an anonymous client on
// the share link, so the auth header is attached only when a token exists,
// never required.
export async function DownloadReportExcel(id) {
  const headers = {};
  try {
    const token = JSON.parse(GetCookieByName("auth"))?.token;
    if (token) headers["x-auth-token"] = token;
  } catch { /* no auth cookie — proceed without header */ }
  return http.get(`${endPoint}/${id}/export-excel`, { headers });
}

// Server renders the live report page in headless Chrome and prints it —
// real browser rendering, so gradients/animations/charts/cross-origin images
// all just work, unlike a client-side DOM-to-canvas library. Can take a while
// (page load + render-settle + PDF generation), so give it a long timeout.
export async function DownloadReportPdf(id) {
  const headers = {};
  try {
    const token = JSON.parse(GetCookieByName("auth"))?.token;
    if (token) headers["x-auth-token"] = token;
  } catch { /* no auth cookie — proceed without header */ }
  return http.get(`${endPoint}/${id}/export-pdf`, { headers, timeout: 150000 });
}

export async function RemovePostFromReport({ reportId, link }) {
  const { data } = await http.put(`${endPoint}/remove/post`, { reportId, link }, {
    headers: { "x-auth-token": JSON.parse(GetCookieByName("auth"))["token"] },
  });
  return data;
}

export async function DeleteReport(id) {
  return http.delete(`${endPoint}/${id}`, {
    headers: { "x-auth-token": JSON.parse(GetCookieByName("auth"))["token"] },
  });
}

export async function UpdateBudget(id, amount) {
  let token;
  try { token = JSON.parse(GetCookieByName("auth"))?.token; } catch { /* no cookie */ }
  if (!token) throw new Error('Not authenticated');
  return http.patch(`${endPoint}/${id}/budget`, { budget: amount }, {
    headers: { "x-auth-token": token },
  });
}

export async function UpdateInfluencerBudget(id, username, budget) {
  return http.patch(`${endPoint}/${id}/influencer-budget`, { username, budget }, {
    headers: { "x-auth-token": JSON.parse(GetCookieByName("auth"))["token"] },
  });
}

export async function UpdateInfluencerZone(id, username, zone) {
  return http.patch(`${endPoint}/${id}/influencer-zone`, { username, zone }, {
    headers: { "x-auth-token": JSON.parse(GetCookieByName("auth"))["token"] },
  });
}

export async function UpdateInfluencerRetailerCode(id, username, retailerCode) {
  return http.patch(`${endPoint}/${id}/retailer-code`, { username, retailerCode }, {
    headers: { "x-auth-token": JSON.parse(GetCookieByName("auth"))["token"] },
  });
}

export async function UpdatePostShares(id, link, shares) {
  return http.patch(`${endPoint}/${id}/post-shares`, { link, shares }, {
    headers: { "x-auth-token": JSON.parse(GetCookieByName("auth"))["token"] },
  });
}

export async function UpdateNow(id) {
  return http.post(`${endPoint}/${id}/update-now`, {}, {
    headers: { "x-auth-token": JSON.parse(GetCookieByName("auth"))["token"] },
  });
}

export async function StopUpdates(id) {
  return http.post(`${endPoint}/${id}/stop-updates`, {}, {
    headers: { "x-auth-token": JSON.parse(GetCookieByName("auth"))["token"] },
  });
}

export async function ResumeUpdates(id) {
  return http.post(`${endPoint}/${id}/resume-updates`, {}, {
    headers: { "x-auth-token": JSON.parse(GetCookieByName("auth"))["token"] },
  });
}

export default {
  FetchReports,
  FetchReportDetails,
  AddReport,
  AddPostsByReport,
  RemovePostFromReport,
  FetchReportStatus,
  RetryReport,
  FetchReportSnapshots,
  BackfillFollowers,
  FetchRefreshInfo,
  FetchComments,
  GetPostComments,
  DownloadReportExcel,
  DownloadReportPdf,
  DeleteReport,
  UpdateBudget,
  UpdateInfluencerBudget,
  UpdateInfluencerZone,
  UpdateInfluencerRetailerCode,
  UpdatePostShares,
  UpdateNow,
  StopUpdates,
  ResumeUpdates,
};
